import React, { Fragment, useEffect, useMemo } from 'react';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import styles from './Home.module.scss';

import Hero from './Hero';
import Plans from './AvailablePlans';
import { trackViewPageEvent } from '@/utils/dataLayer/home';
import CyberBanner from './CyberBanner';
import { useCyberDates, useExecutive } from '@/src/customHooks';
import { getBranding } from '@/redux/wizard/selectors';
import { UF as UFType } from '../../types/uf';
import * as ufSelectors from '../../redux/uf/selectors';
import * as plansSelectors from '../../redux/plans/selectors';

import { landingText } from '@/utils/generalTexts';

const Benefits = dynamic(() => import('./Benefits'));
const RequirementsToContract = dynamic(() => import('./RequirementsToContract')) as React.ComponentType<{ setShowToaster?: (show: boolean) => void; showTabsOnMobile?: boolean }>;
const BannerFooter = dynamic(() => import('./BannerFooter')) as React.ComponentType<{ setShowToaster?: (show: boolean) => void }>;
const AdditionalCoverages = dynamic(() => import('./AdditionalCoverages'));
const BenefitsHomeBanner = dynamic(() => import('./BenefitsHomeBanner'));

type HomeType = {
  loading: boolean;
  setShowToaster?: (show: boolean) => void;
};

const Home = ({ loading, setShowToaster }: HomeType) => {
  const UF: UFType = useSelector(ufSelectors.getUF);
  const coveragesValue = useSelector(plansSelectors.getDentalCat());

  useEffect(() => {
    trackViewPageEvent(branding.code);
  }, []);

  useExecutive();
  const branding = useSelector(getBranding);

  const { isPromo, isCyberDayToday, cyberDay } = useCyberDates(new Date());

  const coveragesCard = useMemo(() => {
    return landingText.pymeValue.cards
      .filter(
        (card) => !!coveragesValue[card.id as keyof typeof coveragesValue] || card.id === 'pawer'
      )
      .map((card) => ({
        ...card,
        title: card.title(UF, coveragesValue[card.id as keyof typeof coveragesValue] || 0),
      }));
  }, [UF, coveragesValue]);

  return (
    <Fragment>
      <Hero />
      {(isCyberDayToday || isPromo) && <CyberBanner cyberDay={cyberDay} />}
      {!loading && <Plans />}
      <RequirementsToContract setShowToaster={setShowToaster} showTabsOnMobile={true} />
      <Benefits />
      <BenefitsHomeBanner />
      <AdditionalCoverages customClass={styles.additional_coverages_custom} cards={coveragesCard} />
      <BannerFooter setShowToaster={setShowToaster} />
    </Fragment>
  );
};

export default Home;
